import React from "react";
import { Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import "./Footer.css";

const Footer = () => {
  return (
    <div>
      <footer className="atf-footer-area atf-section-padding pb-0 pt-5 ">
        <div className="container">
          <div
            className="atf-footer-top wow fadeIn"
            data-wow-duration="1s"
            data-wow-delay="0.2s"
            data-wow-offset="0"
          >
            <Row>
              <div className="col-lg-4 col-md-6 col-12 atf-footer-link">
                <div className="atf-footer-box">
                  <h5>About Company</h5>
                  <p>
                    The agro products are one of the best products in the whole
                    world and anybody can use it. And not only foods, but there
                    are many other agro products that are being used by the
                    people of around the world.
                  </p>
                </div>
              </div>

              <div
                className="col-lg-2 col-md-6 col-12 atf-footer-link wow fadeIn"
                data-wow-duration="1s"
                data-wow-delay="0.3s"
                data-wow-offset="0"
              >
                <h5>Contact</h5>
                <ul className="atf-list-menu list-unstyled">
                  <li>
                    {" "}
                    <Link to="#">
                      <i className="fa fa-home mr-2"></i> Mojgunni, Khulna <br />{" "}
                     Bangladesh
                    </Link>
                  </li>
                  <li>
                    {" "}
                    <Link to="#">
                      <i className="fa fa-phone mr-2"></i>+01911 411 270
                    </Link>
                  </li>
                  <li>
                    {" "}
                    <Link to="#">
                      <i className="fa fa-envelope mr-2"></i>rahmandevbd@gmail.com
                    </Link>
                  </li>
                </ul>
              </div>

              <div
                className="col-lg-2 col-md-6 col-12 atf-footer-link wow fadeIn"
                data-wow-duration="1s"
                data-wow-delay="0.4s"
                data-wow-offset="0"
              >
                <h5>Product Links</h5>
                <ul className="atf-list-menu list-unstyled">
                  <li>
                    <Link to="my-item">
                      <i className="fa fa-angle-right mr-2"></i>Your Item
                    </Link>
                  </li>
                  <li>
                    <Link to="/blog">
                      <i className="fa fa-angle-right mr-2"></i>Blog
                    </Link>
                  </li>
                  <li>
                    <Link to="/all-products">
                      <i className="fa fa-angle-right mr-2"></i>View Product
                    </Link>
                  </li>
                  <li>
                    <Link to="#">
                      <i className="fa fa-angle-right mr-2"></i>Apps Download
                    </Link>
                  </li>
                </ul>
              </div>

              <div
                className="col-lg-4 col-md-6 col-12 atf-footer-link wow fadeIn"
                data-wow-duration="1s"
                data-wow-delay="0.5s"
                data-wow-offset="0"
              >
                <h5>Follow Us</h5>
                <p>
                  Without a doubt, foods represent the most broadly produced
                  agricultural products.
                </p>
                <br />
              </div>
            </Row>
          </div>
        </div>

        <div className="atf-footer-boottom text-center mt-4">
          <Row className="g-0">
            <div className="col-md-12">
              <p>
                ©Copyright - All Right Reserved.Designed{" "}
                <i className="fa fa-heart ml-1 mr-1"></i> by{" "}
                <Link to="">Abdur Rahman</Link>{" "}
              </p>
            </div>
          </Row>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
